import { css, styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentBlockFullWidthVideoBackgroundHolder = styled.div`
  display: contents;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    display: none;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    & + * {
      pointer-events: none;
    }
  }
`;

export const CmsSplitContentBlockFullWidthVideoHolder = styled.div`
  display: contents;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    display: none;
  }
`;

export const CmsSplitContentBlockFullWidthVideoPlaceholder = styled.div`
  width: 50%;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    display: none;
  }
`;

export const CmsSplitContentBlockMovementCounterDigitContainer = styled.div`
  display: inline-block;
  height: 42px;
  width: 34px;
  background: ${colors.brandGreen};
  border-radius: 3px;
  text-align: center;
  line-height: 42px;
  margin-right: 3px;
  position: relative;
  overflow: hidden;
`;

export const CmsSplitContentBlockMovementCounterDigitSlot = styled.div<{
  $number: number;
}>`
  display: flex;
  flex-direction: column;
  width: 34px;
  position: absolute;
  left: 0;
  ${({ $number }) => css`
    top: -${$number * 42}px;
  `}
  transition: top 1s ease;
`;

export const CmsSplitContentBlockMovementCounterDigit = styled.div`
  font-size: 32px;
  font-weight: 400;
  color: white;
`;

export const CmsSplitContentBlockMovementPeopleJoined = styled.div`
  display: inline-block;
  font-style: italic;
  color: ${colors.mediumContentGrey};
`;

export const CmsSplitContentBlock_Box_1 = styled.div`
  flex-direction: column;
  margin: ${-gutterWidth / 4}px;
  width: calc(100% + ${gutterWidth / 2}px);
  min-height: initial;
  position: relative;
  display: flex;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex-direction: row;
    margin: ${-gutterWidth / 2}px;
    width: calc(100% + ${gutterWidth}px);
  }

  &[data-image-text-block-and-show-background-image] {
    padding: ${gutterWidth / 2}px;
    box-shadow: 0 4px 9px rgb(0 0 0 / 0.1);

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding: ${gutterWidth}px;
      box-shadow: none;
    }
  }

  &[data-image-text-block-or-image-quote-block-and-not-show-background-image] {
    border-radius: 12px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      border-radius: 0;
    }
  }

  &[data-flip-on-mobile] {
    flex-direction: column-reverse;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      flex-direction: row;
    }
  }

  &[data-image-text-block] {
    margin: 0;
    width: 100%;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      margin: ${-gutterWidth / 2}px;
      width: calc(100% + ${gutterWidth}px);
    }
  }

  &[data-appearance-equals-full-width] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      min-height: calc(100vh - 300px);
    }
  }
`;

export const CmsSplitContentBlock_Box_2 = styled.div`
  &[data-appearance-not-equals-side-by-side] {
    @media all and (min-width: ${cssBreakpoints.xsUp}) {
      padding-block: ${gutterWidth}px;
    }
  }
`;
